export default "__VITE_ASSET__DGugu3br__"